import React from 'react';
import { ImagePreviewGroup, Image } from '@routific/hive';
import { Row, Col } from 'antd';
import { OrderEventLogDtoModelType } from '../../../../store/mst/models';
import { ProofOfDeliveryPhotoArgDto } from '../../../../store/mst/models/RootStore.base';

export const IMAGE_COLUMN_SPAN = 6;
interface Props {
  log: OrderEventLogDtoModelType | undefined
}

const Photos: React.FC<Props> = ({ log }) => (log?.photos ? (
  <ImagePreviewGroup>
    <Row gutter={[8, 0]}>
      {log.photos.map((photo: ProofOfDeliveryPhotoArgDto) => (
        <Col key={photo.firebaseStorageUuid} span={IMAGE_COLUMN_SPAN}>
          <Image
            src={photo.thumbnail}
            aspectRatio="1:1"
            roundedCorners
            preview={{
              src: photo.url,
            }}
          />
        </Col>
      ))}
    </Row>
  </ImagePreviewGroup>
) : <></>);

export default Photos;
